import React from 'react';
import { bool, string, arrayOf, shape } from 'prop-types';
import { required, email } from 'redux-form-validators';

import styled from 'styled-components';
import { Form, Button, Input, Select } from 'semantic-ui-react';

import FormField from '~/views/common/FormField';
import CommonForm from '~/views/common/Form';


const LoginButton = styled(Button).attrs({
    fluid: true,
    primary: true,
    size: 'large',
    content: 'LOGIN',
})`
    && {
        margin-top: 2rem;
    }
`;

const LoginForm = ({
    isEnvProduction,
    targetOptions,
    productOptions,
    submitting,
    ...rest
}) => (
    <CommonForm {...rest} basic>
        <Form.Group grouped>
            <FormField
                name="username"
                label="Username"
                control={Input}
                placeholder="E-mail address"
                validate={[required(), email()]}
                required
            />

            <FormField
                name="password"
                label="Password"
                control={Input}
                placeholder="Password"
                type="password"
                validate={required()}
                required
            />
        </Form.Group>

        <FormField
            name="product_id"
            label="Product"
            control={Select}
            options={productOptions}
            validate={required()}
            required
            width={4}
        />

        { !isEnvProduction && (
            <FormField
                name="api_url"
                label="Target"
                control={Select}
                options={targetOptions}
                validate={required()}
                required
                width={4}
            />
        ) }

        <LoginButton loading={submitting} />
    </CommonForm>
);


LoginForm.propTypes = {
    isEnvProduction: bool.isRequired,
    targetOptions: arrayOf(shape({
        text: string.isRequired,
        value: string.isRequired,
    }).isRequired).isRequired,
    productOptions: arrayOf(shape({
        text: string.isRequired,
        value: string.isRequired,
    }).isRequired).isRequired,
    submitting: bool.isRequired,
    error: string,
};

export default LoginForm;
